var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLastUpdated = function SvgLastUpdated(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8Zm0-14.728A6.736 6.736 0 0 0 3.272 10 6.736 6.736 0 0 0 10 16.728 6.736 6.736 0 0 0 16.728 10 6.736 6.736 0 0 0 10 3.272Z",
    fill: "#AFAFAF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.364 10.264V5.433h1.272v4.302l2.868 2.853-.896.903-3.244-3.227Z",
    fill: "#AFAFAF"
  })));
};
export default SvgLastUpdated;